import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LessonStringPipe } from './lesson-string.pipe';
import { NumberToArrayPipe } from './number-to-array.pipe';



@NgModule({
  declarations: [
    LessonStringPipe,
    NumberToArrayPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LessonStringPipe,
    NumberToArrayPipe
  ]
})
export class PipesModule { }
